/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function ThLargeIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "th-large", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("rect", { x: 5.5, y: 6.5, width: 14, height: 12, stroke: "currentColor", strokeWidth: 1.2 }),
        React.createElement("path", { d: "M12.5 6.5V18.5M19.5 12.5H5.5", stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(ThLargeIcon);
export default ForwardRef;
//# sourceMappingURL=thLargeIcon.js.map